export default "__VITE_PUBLIC_ASSET__d03906c2__"